<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="url(#paint0_linear_2369_1748)"
    />
    <path
      d="M12 17L12 11.5"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <circle
      cx="12"
      cy="8"
      r="0.5"
      fill="currentColor"
      stroke="currentColor"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2369_1748"
        x1="4"
        y1="4"
        x2="18"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6CAFE" />
        <stop
          offset="1"
          stop-color="#805CFF"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
